import { render, staticRenderFns } from "./ModalCreateCategory.vue?vue&type=template&id=ca622eec&scoped=true&"
import script from "./ModalCreateCategory.vue?vue&type=script&lang=js&"
export * from "./ModalCreateCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateCategory.vue?vue&type=style&index=0&id=ca622eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca622eec",
  null
  
)

export default component.exports